import { Message } from "element-ui";
import router from "@root/router";
import {
  createApolloClient,
  createPresetApolloClientOptions
} from "@gtech/preset-apollo-client";

export function createApolloClientOption() {
  return createPresetApolloClientOptions({
    uri: window.__GTECH_VARIABLES_GRAPHQL_URL__,
    setContextHeaders(headers) {
      // headers["AUTH-TOKEN"] = localStorage.getItem("AuthToken");
      let authName = process.env.VUE_APP_USER_AUTH_TOKEN_STORAGE_KEY;
      headers["AUTH-TOKEN"] =
        localStorage.getItem(authName) || localStorage.getItem("AuthToken");

      headers.appCode = window.__GTECH_VARIABLES_APP_CODE__;
      headers.Language = "zh-cn";
    },
    expiredCode: "0002",
    errorHandler({
      response,
      message,
      code,
      networkError,
      firstExpired,
      expired
    }) {
      // 网络错误
      if (networkError) {
        Message.error("networkError");
        return;
      }

      // 首次过期
      if (firstExpired) {
        Message.error(message);

        // clear localstorage
        localStorage.clear();
        sessionStorage.clear();

        // qiankun 环境下
        router.push({ name: "Login" });

        return;
      }

      // 防止过期时 弹出多个提示
      if (expired) return;

      if (
        code === "wtcn.invalid-user-auth-token" ||
        code === "KOne.invalid-user-auth-token"
      ) {
        Message.error(message);

        // clear localstorage
        localStorage.clear();
        sessionStorage.clear();

        // qiankun 环境下
        router.push({ name: "Login" });

        return;
      }

      // 兼容抛错格式无message
      Message.error(message || code);
    }
  });
}

const defaultApolloOptions: any = createApolloClientOption();

export default defaultApolloOptions;
export const gqlClient = createApolloClient(defaultApolloOptions);
